// import { initializeApp } from 'firebase/app';
// import { getDatabase } from 'firebase/database';
//
// const firebaseConfig = {
//   apiKey: "AIzaSyD8tl3RztrPnGxVwd3V6vvwdgrcm17l-N0", // from Firebase console
//   authDomain: "test-baza-cf9ee.firebaseapp.com",
//   databaseURL: "https://test-baza-cf9ee-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "test-baza-cf9ee",
//   storageBucket: "test-baza-cf9ee.appspot.com",
//   messagingSenderId: "713073784920", // from console
//   appId: "1:713073784920:web:839d811163e2ab6407722d"
// };
//
// const app = initializeApp(firebaseConfig);
// export const db = getDatabase(app);

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// STEFAN TEST FIREBASE
// const firebaseConfig = {
//   apiKey: "AIzaSyB5Tkhh5pywAfpO19Z3O9pvv74CEFJX8cQ",
//   authDomain: "musicdj-test-stefan.firebaseapp.com",
//   databaseURL: "https://musicdj-test-stefan-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "musicdj-test-stefan",
//   storageBucket: "musicdj-test-stefan.firebasestorage.app",
//   messagingSenderId: "893670016553",
//   appId: "1:893670016553:web:4a02e4f059854142817e38",
//   measurementId: "G-2EQTPQNMGM"
// };
// FUSION PROJECT
const firebaseConfig = {
  apiKey: "AIzaSyBR6ypwTtKILYYg8cVPB0zuk5jJtEL_79U",
  authDomain: "test-baza-cf9ee.firebaseapp.com",
  databaseURL: "https://musicdjmdm.europe-west1.firebasedatabase.app",
  projectId: "test-baza-cf9ee",
  storageBucket: "test-baza-cf9ee.appspot.com",
  messagingSenderId: "713073784920",
  appId: "1:713073784920:web:0421ec6765e7c94007722d",
  measurementId: "G-L36Z45BWVK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);

// Problem-device analytics: ONLY the named Firestore database "mdm-analitics".
// Never call getFirestore(app) without the database id - that is "(default)", the MAIN MUSICDJ database,
// which the MDM must never touch (see DATABASES.md).
export const analyticsDb = getFirestore(app, 'mdm-analitics');
export const analyticsFunctions = getFunctions(app, 'europe-west1');